import { get } from 'lodash'
import {
	ADDRESS_TYPE,
	DATA_FIELDS_WITH_TYPE,
	FIELDS,
	TYPE_SELECT_FIELD,
} from 'Src/constants/Address.constants'
import { BaseAddress } from 'Models/address/BaseAddress'
import { SelectItem } from 'Types/item'
import { FieldNames } from 'Constants/FieldNames'

export const getOptionsSelect = (list: string[]): SelectItem[] =>
	list.map(
		(current) =>
			({
				id: current,
				name: current,
			} as SelectItem)
	)

export const getStringSource = (address: BaseAddress, typeAddress = ADDRESS_TYPE.DEFAULT) => {
	const prepareAddress = []
	const postalCode = get(address, 'postal_code', false)
	const DATA_FIELDS = DATA_FIELDS_WITH_TYPE(typeAddress)
	if (postalCode) prepareAddress.push(postalCode)
	FIELDS.forEach((field: string): void => {
		let isValue = get(address, `${field}`, false)
		const dataField = DATA_FIELDS[field]
		const isId = dataField?.options_type === TYPE_SELECT_FIELD.ID
		const fieldType = dataField?.field_type
		let isTypeValue = isId
			? dataField?.options.find((value) => value.id === address?.[fieldType])?.name
			: get(address, fieldType, false)
		if (
			prepareAddress.length > 1 &&
			prepareAddress[prepareAddress.length - 1] === `${isTypeValue} ${isValue}` &&
			field === FieldNames.CITY
		) {
			isTypeValue = false
			isValue = false
		}

		if (isValue && isTypeValue) prepareAddress.push(`${isTypeValue} ${isValue}`)
	})
	return prepareAddress.join(', ')
}

export const getOptionsTypeField = (field: FieldNames, typeAddress = ADDRESS_TYPE.DEFAULT) => {
	switch (field) {
		case FieldNames.REGION:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.SELECT
			}
			break
		case FieldNames.OKTMO_AREA:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.ID
			}
			break
		case FieldNames.OKTMO_SUBAREA:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.ID
			}
			break
		case FieldNames.CITY:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		case FieldNames.SETTLEMENT:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		case FieldNames.PLANNING_STRUCTURE:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		case FieldNames.STREET:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		case FieldNames.HOUSE:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		case FieldNames.BLOCK:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.SELECT
			}
			break
		case FieldNames.BUILDING:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		case FieldNames.FLAT:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		case FieldNames.ROOM:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.OTHER
			}
			break
		default:
			switch (typeAddress) {
				case ADDRESS_TYPE.IBRO:
					return TYPE_SELECT_FIELD.OTHER
				default:
					return TYPE_SELECT_FIELD.SELECT
			}
	}
}
